import { signal } from '@preact/signals-react';
import { supabase } from './supabaseClient';
import { showId } from 'App';

export const demoState = signal<number>(0);
export const hasUserStartedGame = signal<boolean>(false);
export const userAnswer = signal<number>(-1);

export const refreshDemoState = async () => {
  const { data, error } = await supabase.from('live_quiz').select('*').eq('showId', showId).single();

  if (error) {
    console.log('Error fetching live_quiz data:', error.message);
  }

  demoState.value = data?.demo_state ?? 0;
};
